import { render, staticRenderFns } from "./posterListModal.vue?vue&type=template&id=315dd228&scoped=true&"
import script from "./posterListModal.vue?vue&type=script&lang=js&"
export * from "./posterListModal.vue?vue&type=script&lang=js&"
import style0 from "./posterListModal.vue?vue&type=style&index=0&id=315dd228&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315dd228",
  null
  
)

export default component.exports